import { NgxsModuleOptions } from '@ngxs/store';
import { NgxsDevtoolsOptions } from '@ngxs/devtools-plugin';
import { environment } from '@environment/environment';

export const ngxsConfig: NgxsModuleOptions = {
  developmentMode: !environment.production,
};

export const ngxsDevtoolsConfig: NgxsDevtoolsOptions = {
  disabled: environment.production,
};
